import { render } from "./GabineteRequisicaoStatusSelect.vue?vue&type=template&id=1432abab"
import script from "./GabineteRequisicaoStatusSelect.vue?vue&type=script&lang=js"
export * from "./GabineteRequisicaoStatusSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__